<template lang="pug">
.content
  .row
    .col-md-12.member
      div.box_header
        label.title Quản lý yêu cầu đang chờ duyệt
        .clearfix
      div.box-filter
        .row
           .col-md-6.col-sm-6.col-xs-12
              .form-group
                label.control-label Chọn PC muốn xem
                select.form-control.select-filter(@change="onChangePC($event)" v-model.trim="key_pc")
                  option(v-if="lstPC.length === 0" selected) Chọn PC
                  option(v-for='o in lstPC' :value='o.id' :selected="key_pc === o.id") {{o.name}}
      div.box-table(v-if="!$isMobile()" style="max-height: 385px; overflow-y: scroll;" v-on:scroll.passive='handleScroll')
        mbTable(:centerColumns="['name', 'grade', 'classes', 'activity_last']" @onfilterbygrade="filterbygrade" @onfilterbyname="filterbyname" @onfilterbyclasses="filterbyclasses" :data='members' :columns='columns' :filterGrades="lstGrades" :filterClasses="lstClasses" :inlineFilter='true' , v-on:onAcceptItem="acceptItem" v-on:onRefuseItem="refuseItem" v-on:approvalAll="approvalAll" :classesID="key_classes")
      div.card.box-member(v-else)
        .row-header
          span.label-header Tên hiển thị
          .field-header
            input(@change="filterbynameX($event)" placeholder="Tìm theo tên")
        .row-header
          span.label-header Khối lớp
          .field-header
            select(@change="filterbygradeX($event)")
              option( value='') Tất cả
              option(v-for='o in lstGrades' :value='o.id') {{o.name}}
        .row-header
          span.label-header Lớp học
          .field-header
            select(@change="filterbyclassX($event)")
              option( value='') Tất cả
              option(v-for='cc in lstClasses' :value='cc.id' :selected="cc.id === key_classes") {{cc.name}}
        .row-header.last
          span.label-header
          .field-header
            span.confirm-all(@click="approvalAll") Duyệt tất cả
        div.empty-data(v-if='this.members.length === 0') 
          span Không tìm thấy dữ liệu

        div.list-item(v-else style="overflow-y: scroll;" v-on:scroll.passive='handleScrollX')
          .row-item(v-for='item in members')
            .row-data.custom-join-column
              .board-img
                img.img.responsive(:src="require('../../assets/images/faces/ic_AvatarDefault.svg')" v-if="item.user.avatar === '' || item.user.avatar === null")
                img.img.responsive(:src="item.user.avatar" v-else)
              .board-info
                span {{item.user.fullname}}
            .row-data
              span.label-header Khối lớp
              .row-value {{item.classes.grade.name}}
            .row-data
              span.label-header Lớp học
              .row-value {{item.classes.name}}
            .row-data
              span.label-header Ngày yêu cầu
              .row-value {{formatDate(item.created_at)}}
            .row-data
              span.label-header
              .row-value
                small(@click="acceptItem(item)")
                  img(:src="require('../../assets/images/faces/ic_check.svg')")
                  span Chấp nhận
                small(@click="refuseItem(item)")
                  img(:src="require('../../assets/images/faces/ic_clear.svg')")
                  span Từ chối
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import mbTable from './mbTableApproval'
import moment from 'moment'
export default {
  components: {
    mbTable
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      members: [],
      membersAlls: [],
      columns: [
        { key: 'stt', title: 'STT' },
        { key: 'cover', title: 'Avatar', type: 'image' },
        { key: 'name', title: 'Tên hiển thị', type: 'user_name' },
        { key: 'grade', title: 'Khối lớp', type: 'grade_text' },
        { key: 'classes', title: 'Lớp học', type: 'class_text' },
        { key: 'date', title: 'Ngày yêu cầu', type: 'date' },
        { key: 'action', title: 'Hành động', type: 'action' }
      ],
      limit: 10,
      offset: 0,
      lstPC: [],
      lstClasses: [],
      lstGrades: [],
      lstHistory: [],
      filtername: '',
      filtergrade: '',
      filterClasses: '',
      key_pc: 0,
      key_classes: 0,
      timeout: 0,
      loader: null,
      MdNotification
    }
  },
  mounted () {
    this.show()
    if (this.$route.query.id !== undefined && this.$route.query.id > 0) {
      this.key_pc = this.$route.query.id
      this.timeout = 100
    }
    if (this.$route.params.class_id !== undefined && this.$route.params.class_id > 0) {
      this.key_classes = this.$route.params.class_id
      this.filterClasses = this.key_classes
    }
    setTimeout(() => {
      this.getAllPC()
      setTimeout(() => {
        this.getMemberToPC()
      }, 100)
      setTimeout(() => {
        this.getClassPC()
      }, 200)
      this.loader.hide()
    }, this.timeout)
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        container: null,
        canCancel: true,
        onCancel: this.onCancel
      })
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - HH:mm')
    },
    onItemEdit(payload) {
      this.$router.push({name: 'member_edit', params: {pc_id: payload.pc_id, class_id: payload.id}, query: {id: payload.pc_id}})
    },
    handleScroll: function(e) {
      if ((e.target.scrollHeight - 385) === Math.round(e.target.scrollTop) || (e.target.scrollHeight - 385) === Math.floor(e.target.scrollTop)) {
        this.limit = this.members.length + 10
        this.getMemberToPC()
      }
    },
    handleScrollX: function(e) {
      if ((e.target.scrollHeight - 538) === Math.round(e.target.scrollTop) || (e.target.scrollHeight - 538) === Math.floor(e.target.scrollTop)) {
        this.limit = this.members.length + 5
        this.getMemberToPC()
      }
    },
    filterbyname(valueName) {
      this.filtername = ''
      if (valueName !== '') {
        this.filtername = valueName
      }
      this.getMemberToPC()
    },
    filterbyclasses(valueName) {
      this.filterClasses = ''
      if (valueName !== '') {
        this.filterClasses = valueName
      }
      this.getMemberToPC()
    },
    filterbygrade(valueGrade) {
      this.filtergrade = ''
      if (valueGrade !== '') {
        this.filtergrade = valueGrade
      }
      this.getMemberToPC()
    },
    filterbynameX(event) {
      var valueName = event.target.value
      this.filtername = ''
      if (valueName !== '') {
        this.filtername = valueName
      }
      this.getMemberToPC()
    },
    filterbyclassX(event) {
      var valueName = event.target.value
      this.filterClasses = ''
      if (valueName !== '') {
        this.filterClasses = valueName
      }
      this.getMemberToPC()
    },
    filterbygradeX(event) {
      var valueGrade = event.target.value
      this.filtergrade = ''
      if (valueGrade !== '') {
        this.filtergrade = valueGrade
      }
      this.getMemberToPC()
    },
    onChangePC (event) {
      this.show()
      this.key_classes = 0
      this.filterClasses = 0
      this.key_pc = Number(event.target.value)
      this.members = []
      setTimeout(() => {
        this.getMemberToPC()
        this.loader.hide()
      }, 100)
      setTimeout(() => {
        this.getClassPC()
      }, 200)
    },
    onChangeClass(event) {
      this.show()
      this.key_classes = Number(event.target.value)
      this.members = []
      setTimeout(() => {
        this.getMemberToPC()
        this.loader.hide()
      }, 100)
    },
    async getCountUserToPC() {
      if (this.key_pc > 0 && this.key_classes > 0) {
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_USER_JOIN_PC_COUNT_STATUS),
          variables: {
            pc_id: Number(this.key_pc),
            classes_id: Number(this.key_classes),
            status: 1
          }
        })
        this.textApproval = this.numberWithCommas(data.pc_user_aggregate.aggregate.count)
      }
    },
    memberAdd() {
      this.$router.push({name: 'member_add', query: this.$route.query, params: {pc_id: this.key_pc, class_id: this.key_classes}})
    },
    async checkExerciseUserExist($exerciseID, $userID, $classID) {
      var isExists = -1
      var objWhere = {
        exercise_id: {'_eq': $exerciseID},
        user_id: {'eq': $userID},
        class_id: {'_eq': $classID}
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.CHECK_EXERCISE_USER_EXIST2),
        variables: {
          where: objWhere
        }
      })
      if (data && data.exercise_user.length > 0) {
        // nếu is_delete tai khoan bi xoa
        isExists = data.exercise_user[0].is_delete ? 2 : 1
      } else isExists = 0
      return isExists
    },
    async assignExerciseUser(exerciseIDs, userID, classID) {
      if (exerciseIDs !== null && exerciseIDs.length > 0) {
        for (let i = 0; i < exerciseIDs.length; i++) {
          var isExists = await this.checkExerciseUserExist(parseInt(exerciseIDs[i]), userID, classID)
          if (isExists === 0) {
            let objInput = {
              exercise_id: parseInt(exerciseIDs[i]),
              user_id: userID,
              class_id: classID,
              created_by: this.$store.getters.user,
              updated_by: this.$store.getters.user
            }
            await this.$apollo.mutate({
              mutation: gql(graphql.CREATE_EXERCISE_USER),
              variables: {object: objInput}
            }).catch((error) => {
              this.loader.hide()
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                this.$router.go(0)
              }
              console.error(error.message)
            })
          } else if (isExists === 2) {
            let objWhere = {
              exercise_id: {_eq: parseInt(exerciseIDs[i])},
              user_id: {_eq: userID},
              class_id: {_eq: classID}
            }
            let objInput = {
              is_delete: false,
              updated_by: this.$store.getters.user
            }
            await this.$apollo.mutate({
              mutation: gql(graphql.UPDATE_EXERCISE_USER),
              variables: {objWhere: objWhere, objInput: objInput}
            }).catch((error) => {
              this.loader.hide()
              if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
                this.$router.go(0)
              }
              console.error(error.message)
            })
          }
        }
      }
    },
    acceptItem(item) {
      try {
        this.$modal.show('dialog', {
          title: 'Xác nhận',
          text: 'Bạn có chắc chấp nhận duyệt thành viên này không?',
          class: 'col-md-6 col-12 box-popup-confirm',
          buttons: [
            {
              title: 'Xác nhận',
              default: true,
              class: 'btn btn-primary confirm-delete-dialog',
              handler: () => {
                this.show()
                var objWhere = {
                  pc_id: {_eq: item.pc_id},
                  classes_id: {_eq: item.classes_id},
                  user_id: {_eq: item.user_id}
                }
                var objInput = {
                  status: 2,
                  date_approval: new Date(),
                  user_approval: this.$store.getters.user,
                  updated_by: this.$store.getters.user
                }
                // console.log('variables', variables)
                this.$apollo.mutate({
                  mutation: gql(graphql.UPDATE_PC_USER_ALL),
                  variables: {objWhere: objWhere, objInput: objInput}
                }).then((respon) => {
                  if (respon.data.update_pc_user.affected_rows) {
                    // assign bai tap cho user
                    this.assignExerciseUser(item.classes.exercise_ids, item.user_id, item.classes_id)
                    // lọc lại danh sách thành viên
                    this.members.splice(this.members.findIndex(function(obj) {
                      return obj.user_id === item.user_id && obj.classes_id === item.classes_id
                    }), 1)
                    var pcID = item.pc_id
                    var userID = item.user_id
                    var returnData = this.lstPC.filter(o => o.id === pcID)
                    var description = ''
                    if (returnData && returnData.length > 0) {
                      description = returnData[0].name
                    }
                    this.createHistoryPC(pcID, userID, 'APPROVAL', 'Duyệt tham gia vào PC ' + description)
                    this.showNotification('Đã duyệt thành công', 'success', 'top', 'right', 7000)
                    this.$router.go(0)
                  }
                }).catch((error) => {
                  console.error(error)
                })
                this.$modal.hide('dialog')
                this.loader.hide()
              }
            },
            {
              title: 'Hủy yêu cầu',
              class: 'btn btn-primary cancel-delete-dialog'
            }
          ]
        })
      } catch (e) {
        console.error(e)
      }
    },
    refuseItem(item) {
      try {
        this.$modal.show('dialog', {
          title: 'Xác nhận',
          text: 'Bạn có chắc từ chối thành viên này không?',
          class: 'col-md-6 col-12 box-popup-confirm',
          buttons: [
            {
              title: 'Xác nhận',
              default: true,
              class: 'btn btn-primary confirm-delete-dialog',
              handler: () => {
                this.show()
                var objWhere = {
                  pc_id: {_eq: item.pc_id},
                  classes_id: {_eq: item.classes_id},
                  user_id: {_eq: item.user_id}
                }
                var objInput = {
                  status: 3,
                  position: item.position,
                  user_approval: this.$store.getters.user,
                  updated_by: this.$store.getters.user
                }
                this.$apollo.mutate({
                  mutation: gql(graphql.UPDATE_PC_USER_ALL),
                  variables: {objWhere: objWhere, objInput: objInput}
                }).then((respon) => {
                  if (respon.data.update_pc_user.affected_rows) {
                    this.members.splice(this.members.findIndex(function(obj) {
                      return obj.user_id === item.user_id && obj.classes_id === item.classes_id
                    }), 1)
                    var pcID = item.pc_id
                    var userID = item.user_id
                    var returnData = this.lstPC.filter(o => o.id === pcID)
                    var description = ''
                    if (returnData && returnData.length > 0) {
                      description = returnData[0].name
                    }
                    this.createHistoryPC(pcID, userID, 'REFUSE', 'Từ chối tham gia vào PC ' + description)
                    this.showNotification('Đã từ chối duyệt thành viên', 'success', 'top', 'right', 7000)
                    this.$router.go(0)
                  }
                }).catch((error) => {
                  console.error(error)
                })
                this.$modal.hide('dialog')
                this.loader.hide()
              }
            },
            {
              title: 'Hủy yêu cầu',
              class: 'btn btn-primary cancel-delete-dialog'
            }
          ]
        })
      } catch (e) {
        console.error(e)
      }
    },
    approvalAll () {
      if (this.members.length > 0) {
        try {
          this.$modal.show('dialog', {
            title: 'Xác nhận',
            text: 'Bạn có chắc muốn duyệt tất cả thành viên không?',
            class: 'col-md-6 col-12 box-popup-confirm',
            buttons: [
              {
                title: 'Xác nhận',
                default: true,
                class: 'btn btn-primary confirm-delete-dialog',
                handler: () => {
                  this.show()
                  for (let index = 0; index < this.members.length; index++) {
                    const item = this.members[index]
                    var objWhere = {
                      pc_id: {_eq: item.pc_id},
                      classes_id: {_eq: item.classes_id},
                      user_id: {_eq: item.user_id}
                    }
                    var objInput = {
                      status: 2,
                      date_approval: new Date(),
                      user_approval: this.$store.getters.user,
                      updated_by: this.$store.getters.user
                    }
                    // console.log('variables', variables)
                    this.$apollo.mutate({
                      mutation: gql(graphql.UPDATE_PC_USER_ALL),
                      variables: {objWhere: objWhere, objInput: objInput}
                    }).then((respon) => {
                      if (respon.data.update_pc_user.affected_rows) {
                        // assign bai tap trong user
                        this.assignExerciseUser(item.classes.exercise_ids, item.user_id, item.classes_id)
                        // lọc lại danh sách thành viên
                        this.members.splice(this.members.findIndex(function(obj) {
                          return obj.user_id === item.user_id && obj.classes_id === item.classes_id
                        }), 1)
                        var pcID = item.pc_id
                        var userID = item.user_id
                        var returnHistory = this.lstHistory.filter(h => h.pc_id === pcID && h.user_id === userID)
                        if (Object.entries(returnHistory).length === 0) {
                          this.lstHistory.push({pc_id: pcID, user_id: userID})
                          var returnData = this.lstPC.filter(o => o.id === pcID)
                          var description = ''
                          if (returnData && returnData.length > 0) {
                            description = returnData[0].name
                          }
                          this.createHistoryPC(pcID, userID, 'APPROVAL', 'Duyệt tham gia vào PC ' + description)
                        }
                        if (this.members.length === 0) {
                          this.loader.hide()
                          this.$modal.hide('dialog')
                          this.showNotification('Đã duyệt tất cả thành viên', 'success', 'top', 'right', 7000)
                          this.$router.go(0)
                        }
                      }
                    }).catch((error) => {
                      console.error(error)
                    })
                  }
                }
              },
              {
                title: 'Hủy yêu cầu',
                class: 'btn btn-primary cancel-delete-dialog'
              }
            ]
          })
        } catch (e) {
          console.error(e)
        }
      }
    },
    addMinutes(dt, minutes) {
      var now = new Date(dt.getTime() + minutes * 60000)
      return (now.getFullYear() + '-' + (((now.getMonth() + 1) < 10) ? ('0' + (now.getMonth() + 1)) : ((now.getMonth() + 1))) + '-' + (now.getDate()) + ' ' + now.getHours() + ':' + ((now.getMinutes() < 10) ? ('0' + now.getMinutes()) : (now.getMinutes())) + ':' + ((now.getSeconds() < 10) ? ('0' + now.getSeconds()) : (now.getSeconds())))
    },
    async createHistoryPC(pcID, userID, action, description) {
      var objInput = {
        pc_id: pcID,
        user_id: userID,
        action: action,
        name: 'TEACHER',
        description: description,
        access_time: this.addMinutes(new Date(), 10)
      }
      await this.$apollo.mutate({
        mutation: gql(graphql.CREATE_PC_HISTORY),
        variables: {objInput: objInput}
      })
    },
    numberWithCommas(number) {
      if (number !== undefined && number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return 0
    },
    async getMemberToPC() {
      if (this.key_pc > 0) {
        await this.getMemberAllToPC()
        await this.getCountUserToPC()
        let variables = {
          pc_id: Number(this.key_pc),
          limit: 10,
          status: 1,
          order_by: {updated_at: 'asc'}
        }
        if (this.filtername !== '') {
          variables = Object.assign(variables, {fullname: '%' + this.filtername + '%'})
        }
        if (this.filterClasses !== '' && this.filterClasses > 0) {
          variables = Object.assign(variables, {classes_id: this.filterClasses})
        }
        if (this.filtergrade !== '' && this.filtergrade > 0) {
          variables = Object.assign(variables, {grade_id: this.filtergrade})
        }
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_USER_JOIN_PC),
          fetchPolicy: 'no-cache',
          variables: variables
        })
        this.members = data.pc_user
      }
    },
    async getMemberAllToPC() {
      let variables = {
        pc_id: Number(this.key_pc),
        status: 1
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_USER_JOIN_PC),
        fetchPolicy: 'no-cache',
        variables: variables
      })
      if (data && data !== null && data.pc_user !== null && data.pc_user.length > 0) {
        this.membersAlls = []
        for (let index = 0; index < data.pc_user.length; index++) {
          const element = data.pc_user[index]
          var exists = this.membersAlls.indexOf(element.classes_id)
          if (exists === -1) this.membersAlls.push(element.classes_id)
        }
      }
    },
    async getAllPC() {
      const {data} = await this.$apollo.query({
        query: gql(graphql.GET_USER_PC_GROUP_STATUS),
        fetchPolicy: 'no-cache',
        variables: {
          where: {user_id: {_eq: this.$store.getters.user}, status: {_eq: 1}},
          wherePCUser: {status: {_eq: 1}, is_delete: {_eq: false}}
        }
      })
      this.lstPC = data.private_community
      this.lstPC = this.lstPC.filter(obj => obj.pc_users !== null && obj.pc_users.length > 0)
    },
    async getClassPC() {
      if (this.key_pc > 0) {
        this.lstClasses = []
        this.lstGrades = []
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_CLASSES_OF_PC),
          fetchPolicy: 'no-cache',
          variables: {
            where: {
              pc_id: {_eq: this.key_pc}
            }
          }
        })
        if (data && data !== null) {
          var fileList = data.classes
          if (this.membersAlls.length > 0) {
            this.lstClasses = fileList.filter(event => this.membersAlls.length > 0 && this.membersAlls.indexOf(event.id) > -1)
          } else this.lstClasses = fileList
          if (this.lstClasses && this.lstClasses.length > 0) {
            for (let index = 0; index < this.lstClasses.length; index++) {
              const element = this.lstClasses[index]
              var exists = this.lstGrades.filter(item => item.id === element.grade.id)
              if (exists.length === 0 || Object.entries(exists).length === 0) {
                this.lstGrades.push({id: element.grade.id, name: element.grade.name})
              }
            }
          }
        }
      }
    },
    async getUserJoinPC($pcID, $classID, $userID) {
      var isExists = -1
      var variables = {
        pc_id: $pcID,
        classes_id: $classID,
        user_id: $userID
      }
      const {data} = await this.$apollo.query({
        query: gql(graphql.CHECK_USER_JOIN_PC),
        fetchPolicy: 'no-cache',
        variables: variables
      })
      if (data && data.pc_user.length > 0) {
        // nếu is_delete tai khoan bi xoa
        isExists = data.pc_user[0].is_delete ? 2 : 1
      } else isExists = 0
      return isExists
    }
  },
  apollo: {
  }
}
</script>

<style lang="scss">
.member{
  .box_header{
    label.title{
      text-align: left; 
      font-size:20px;
      font-weight:bold;
      font-family: 'adobe-clean', sans-serif;
      letter-spacing: 0px;
      color: #5F6468;
      display:inline-block
    }
  }
  .form-group{
    label{color: #333;font-weight: bold; font-size: 12px; margin-bottom: 5px;}
    input, select{border-radius: 10px;}
  }
  .box-filter{ background: #fff; padding: 20px; border-radius: 10px; margin-top: 20px;
    .form-group{margin: 0;}
    button{border-radius: 5px; height: 48px; padding: 0 30px; font-size: 13px;
      &.active{background: #FFD311 0% 0% no-repeat padding-box; border: 1px solid #FFD311; margin-right: 30px;}
      &.copy{background: #fff; border: 1px solid #FFD311;}
    }
    .box-request{width: 50%; float: left;
      .request-img{float: left;height: 48px; width: 48px; text-align: center; margin-right: 15px;
        img{ max-width: 100%; height: auto;}
      }
      .request-info{float: left;
        span{display: block; color: #9B9B9B; font-size: 14px;
          &.number{font-weight: bold; font-size: 23px; text-decoration: underline; margin-top: 10px;
            &.text-blue{color: #3A9F00;}
            &.text-danger{color: #D63131;}
          }
        }
      }
    }
  }
}
.box-table{ background: #FFFFFF 0% 0% no-repeat padding-box;box-shadow: 0px 1px 3px #00000029;padding:10px;margin-top:20px;border-radius: 10px;
  .table{margin-bottom: 0;}
}
.list-action {cursor: pointer;}

.box-popup-confirm{box-shadow: 0px 3px 6px #00000029; border-radius: 10px !important;
  .dialog-content{ padding: 0;
    .dialog-c-title {text-transform: uppercase; text-align: left;font-size:17px; font-family: Helvetica;letter-spacing: 0px;color: #343A40; border-bottom: 1px solid #DFE2E6; padding: 12px 15px 15px; font-weight: bold; margin-bottom: 15px;}
    .dialog-c-text{padding: 0 15px;}
  }
  .vue-dialog-buttons {justify-content: center;display: flex; border: 0! important; margin-top: 30px; margin-bottom: 5px;
    .confirm-delete-dialog {background: #FFD311 0% 0% no-repeat padding-box! important;border-radius: 5px; width: 160px;color: #23180A! important;margin-right: 10px;flex: unset! important;}
    .cancel-delete-dialog, .cancel-delete-dialog:hover {background: #FFFFFF 0% 0% no-repeat padding-box! important;border: 1px solid #FFD311;border-radius: 5px;width: 160px;color: #23180A! important;flex: unset! important;}
  }
}
.confirm-all{text-align: left; cursor: pointer; text-decoration: underline;font-size: 13px;letter-spacing: 0px;color: #1A0DAB;}
@media screen and (min-width: 768px){
  .vue-dialog {
    width: 500px! important;
  }
}
@media screen and (max-width: 991px){
  .box_header{
    label.title{display: block;}
    label.plus{display: inline-block;float: none;margin-top: 15px;}
    label.title-pc{display: block;}
  }
  .box-filter{
    .center-button{text-align: center; margin-top: 15px !important;
      button{padding: 0 15px !important;}
    }
    .box-request{width: 50%; float: left;
      .request-img{float: none !important; margin: 0 auto 15px !important;
        img{ max-width: 100%; height: auto;}
      }
    }
  }
  .box-member{background: #FFFFFF 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029; padding: 15px;
    .row-header{border: 1px solid #E0E0E0;border-top: 0;background: #FAFAFA 0% 0% no-repeat padding-box; 
      .label-header{display: inline-block; line-height: 30px;width: 40%;font-weight: bold;text-align: right; padding-right: 10px;}
      .field-header{padding: 3px 10px; display: inline-block; width: 60%; background: #EAEAEA 0% 0% no-repeat padding-box;
        input, select{width: 100%;border-radius: 10px; padding: 3px 10px; background: #fff;border: 1px solid #B4B4B4;}
      }
      &:first-child{border-top: 1px solid #E0E0E0;border-top-left-radius: 10px;border-top-right-radius: 10px;overflow: hidden;}
      &.last{border-bottom-left-radius: 10px !important;border-bottom-right-radius: 10px !important;overflow: hidden;}
    }
    .empty-data{margin-top: 20px; background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 10px; text-align: center; padding: 5px;}
    .list-item{margin-top: 20px;
      .row-item{background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 10px; padding: 7px 5px;margin-bottom: 10px;
        &:first-child{margin-bottom: 10px;}
        .row-data{
          .label-header{display: inline-block; width: 40%;font-weight: bold;text-align: left;}
          .row-value{padding: 3px 0; display: inline-block; width: 60%;
            &.title{font-size: 15px; font-weight: bold; margin-bottom: 15px;display: block;}
            &.link{text-decoration: underline; color:#554BC1;}
            select{background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 10px; opacity: 1; padding: 6px;width: 100%;}
            small{margin-right: 10px; float: left;
              &:last-child{margin-right: 0;}
              img{width: 16px;height: 16px;}
              span{font-size: 13px;color: #9B9B9B; margin-left: 5px;}
            }
            img.img{border-radius: 50%;width: 30px; height: 30px;}
          }
          &.custom-join-column{display: flex;justify-content: center; align-items: center; margin-bottom: 10px;
            .board-img{width: 48px; height: 48px; margin-right: 10px; margin: 0 auto; border-radius: 50%; overflow: hidden; position: relative;
              img{max-width: 100%; height: auto; }
            }
            .board-info{ width: calc(100% - 50px); display: inline-flex; margin-left: 10px;
              span{font-size: 15px; font-weight: bold; display: block;}
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 560px){
  .box-popup-confirm{margin: 0 15px !important; width: calc(100% - 30px) !important; left: auto !important;}
}
@media screen and (max-width: 320px){
  .member{
    .box-filter{
      button{padding: 0 10px !important;
        &.active{margin-right: 10px !important;}
      }
    }
  } 
}
</style>



// WEBPACK FOOTER //
// approval.vue?7eed0f2b